import { ApiConfig } from 'common/models/api-service/api-config.model';
import { CONTROLLER, METHOD } from 'common/config/endpoint.config';
import {
    AssignRoleApiPayload,
    DeleteUserRoleApiPayload
} from 'modules/user-management/models/user.model';
import { ApiMethods } from 'common/enums/api-methods.enum';

const userConfig = {
    getUserList: (): ApiConfig =>
        new ApiConfig(`${CONTROLLER.APPLICATION_ROLE}/${METHOD.USER_LIST}`),
    deleteRole: (payload: DeleteUserRoleApiPayload): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.APPLICATION_ROLE}/${METHOD.APPLICATIONROLE.DELETE_USER_ROLE}`,
            ApiMethods.POST,
            '',
            payload
        ),
    assignRole: (payload: AssignRoleApiPayload): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.APPLICATION_ROLE}/${METHOD.APPLICATIONROLE.ASSIGN_USER_ROLE}`,
            ApiMethods.POST,
            '',
            payload
        ),
    editRole: (payload: AssignRoleApiPayload): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.APPLICATION_ROLE}/${METHOD.APPLICATIONROLE.EDIT_USER_ROLE}`,
            ApiMethods.POST,
            '',
            payload
        ),
    getRoleList: (payload: any): ApiConfig =>
        new ApiConfig(`${CONTROLLER.APPLICATION_ROLE}/${METHOD.LIST}`, ApiMethods.GET, '', payload),
    getUserRoles: (payload: any): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.APPLICATION_ROLE}/${METHOD.USER_ROLE_LIST}`,
            ApiMethods.POST,
            '',
            payload
        )
};

export default userConfig;
